import styled from "styled-components";
import theme from "../../../utils/theme";

const { colors, templateColors, fontSizes } = theme;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0e8dd;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  min-height: 100vh;
`;

export const HeroSection = styled.div`
  width: 100%;
  background-color: #f0e8dd;
  padding: 72px 24px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 52px 24px 32px;
  }
`;

export const HeroGreeting = styled.p`
  font-size: 15px;
  color: #5a4e45;
  margin: 0 0 12px 0;
  font-weight: 400;
`;

export const HeroGymName = styled.h1`
  font-size: 46px;
  font-weight: 800;
  color: #1a1a1a;
  line-height: 1.1;
  letter-spacing: -1px;
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 34px;
  }
`;

export const HeroHours = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #2e2c2b;
  margin: 0;
`;

export const WhiteCard = styled.div`
  width: 100%;
  background-color: #f0e8dd;
  padding: 0 16px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 480px) {
    padding: 0 12px 60px;
  }
`;

export const ContentCard = styled.div`
  width: 100%;
  max-width: 560px;
  background-color: #fff;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);

  @media (max-width: 480px) {
    padding: 20px 16px;
  }
`;

export const GymMiniRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
`;

export const GymMiniLogo = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 10px;
  object-fit: contain;
  background: #f0f0f0;
`;

export const MembershipRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 560px;
  padding: 16px 0 0;
  border-top: 1px solid #ede8e1;
`;

export const MembershipRowText = styled.span`
  font-size: 13px;
  color: #555;
`;

export const ManageButton = styled.button`
  border: 1.5px solid #1a1a1a;
  background: transparent;
  border-radius: 30px;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
  &:hover { background: #1a1a1a; color: #fff; }
`;

export const CheckInButton = styled.button`
  background: #1a1a1a;
  color: #fff;
  border: none;
  border-radius: 30px;
  padding: 12px 0;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  margin-top: 4px;
  transition: opacity 0.15s;
  &:hover { opacity: 0.85; }
`;

export const FilterChip = styled.button<{ active?: boolean }>`
  border: 1.5px solid ${p => p.active ? '#1a1a1a' : '#ddd'};
  background: ${p => p.active ? '#1a1a1a' : 'transparent'};
  color: ${p => p.active ? '#fff' : '#333'};
  border-radius: 30px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
`;

export const MsOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
`;

export const MsSheet = styled.div`
  background: #faf6f1;
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;
  padding: 14px 24px 44px;
  width: 100%;
  max-width: 560px;
`;

export const MsLabel = styled.p`
  font-size: 11px;
  font-weight: 700;
  color: #9CA3AF;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 0 0 10px;
`;

export const MsTitle = styled.h2`
  font-size: 26px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.5px;
  line-height: 1.2;
  margin: 0 0 4px;
`;

export const MsSubtitle = styled.p`
  font-size: 15px;
  color: #888;
  margin: 0 0 6px;
`;

export const MsPrice = styled.p`
  font-size: 17px;
  font-weight: 700;
  color: #3a3028;
  margin: 6px 0 0;
`;

export const MsPrimaryBtn = styled.button`
  width: 100%;
  background: #1a1a1a;
  color: #fff;
  border: none;
  border-radius: 30px;
  padding: 17px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 10px;
  transition: opacity 0.15s;
  &:hover { opacity: 0.85; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const MsSecondaryBtn = styled.button`
  width: 100%;
  background: transparent;
  color: #1a1a1a;
  border: 1.5px solid #1a1a1a;
  border-radius: 30px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 10px;
  transition: all 0.15s;
  &:hover { background: #1a1a1a; color: #fff; }
`;

export const MsTextLink = styled.button`
  background: none;
  border: none;
  width: 100%;
  padding-top: 8px;
  font-size: 13px;
  color: #9CA3AF;
  cursor: pointer;
  text-align: center;
  &:hover { color: #555; }
`;

export const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: center;
  background-color: #f0e8dd;
  width: 100%;
  padding: 0; 

  @media (max-width: 1224px) {
    justify-content: center; 
    width: 90%; 
    margin-top: 5px;
  }
`;

export const Tile = styled.span`
  color: ${colors.black};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  @media (max-width: 1224px) {
    font-size: 12px;
    font-weight: 600;
    line-height: 15px;
  }
`;

export const GymHopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0e8dd;
  width: 100%;
  max-width: 85%;
  overflow: hidden;
  border-radius: 12px;
  margin: 40px 0;
  padding: 32px 16px;

  @media (max-width: 1224px) {
    margin: 20px 0;
    max-width: 95%;
    padding: 24px 8px;
  }
`;

export const Box = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1224px) {
    width: 80%;
    text-align: center;
  }
`;

export const GymHop = styled.div`
  background-color: #f0e8dd;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  align-self: center;
  justify-content: space-between;
  position: relative;
  height: 600px;
  width: 100%;
  z-index: 20;
  margin-top: 3%;
  overflow-y: scroll;
  gap: 2px;
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }

  @media (max-width: 1224px) {
    max-width: 90%;
    overflow-x: hidden;
    justify-content: center;
  }
`;

export const GymHopeTitle = styled.span`
  color: ${colors.black};
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  margin-bottom: 8px;
  text-align: center;
  
  @media (max-width: 1224px) {
    font-size: 22px;
  }
`;

export const GymHopeSubtitle = styled.span`
  font-weight: 500;
  font-size: ${fontSizes.subtitle};
  color: ${templateColors.lightYellow};

  @media (max-width: 1224px) {
    font-size: ${fontSizes.descriptionMobile};
    margin-top: 15px;
  }
`;

export const GymHopeDescription = styled.span`
  font-weight: 400;
  font-size: ${fontSizes.description};
  color: ${templateColors.grey};
  text-align: center;
  max-width: 80%;
  margin-bottom: 16px;
  
  @media (max-width: 1224px) {
    font-size: ${fontSizes.descriptionMobile};
    line-height: 1.4;
    max-width: 90%;
  }
`;

export const ScrollableContainer = styled.div`
  width: 100%;
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }
  
  @media (max-width: 768px) {
    max-height: 500px;
  }
`;

export const BottomContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 24px;
  width: 100%;
  padding: 16px 8px;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// Modal Components
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 1000;
  padding: 0 20px;
  overflow-y: auto;
`;

export const ModalContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 90%;
  max-width: 1000px;
  height: auto;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
  margin: 120px auto 60px;
  
  @media (max-width: 768px) {
    width: 90%;
    max-width: 500px;
    margin: 100px auto 60px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #000;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  
  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

export const ModalGallery = styled.div`
  position: relative;
  background-color: #f5f5f5;
  
  @media (min-width: 769px) {
    width: 50%;
    height: 400px;
  }
  
  @media (max-width: 768px) {
    height: 240px;
    width: 100%;
  }
`;

export const GalleryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const GalleryNavButton = styled.button<{ left?: boolean; right?: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${props => props.left ? 'left: 15px;' : ''}
  ${props => props.right ? 'right: 15px;' : ''}
  background-color: rgba(255, 255, 255, 0.8);
  color: #000;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.95);
  }
`;

export const ModalContent = styled.div`
  padding: 20px;
  box-sizing: border-box;
  
  @media (min-width: 769px) {
    width: 50%;
    overflow-y: auto;
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ModalSection = styled.div`
  margin-bottom: 24px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin: 0 0 12px 0;
`;

export const FeaturesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  
  @media (max-width: 768px) {
    padding-right: 8px;
  }
`;

export const FeatureItem = styled.div`
  background-color: #f5f5f5;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
`;

export const LocationInfo = styled.div`
  font-size: 16px;
  color: #555;
`;

export const PriceInfo = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #000;
`;

export const ModalFooter = styled.div`
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    align-items: center;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const SelectButton = styled.button`
  background-color: ${templateColors.lightDark};
  color: #FFF;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
  
  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const SoldOutButton = styled(SelectButton)`
  background-color: #9e9e9e;
  cursor: not-allowed;
  opacity: 0.8;
  
  &:hover {
    opacity: 0.8;
  }
`;

// Next Gym Selector Styled Components
export const NextGymSelectorContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto 8px;
  padding: 18px 0 0;
  border-top: 1px solid #f0f0f0;
`;

export const NextGymSelectorContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const NextGymLeftSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NextGymTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 6px 0;
  color: ${colors.black};
`;

export const NextGymDate = styled.p`
  font-size: 16px;
  margin: 0 0 6px 0;
  color: ${colors.black};
`;

export const NextGymMessage = styled.p`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: 4px 0 0 0;
  color: ${colors.darkGrey || '#666'};
  
  svg {
    margin-right: 6px;
  }
`;

export const NextGymRightSection = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const NextGymAction = styled.div<{ selected?: boolean }>`
  background-color: ${props => props.selected ? '#fff' : '#1a1a1a'};
  border-radius: 30px;
  padding: 14px 24px;
  color: ${props => props.selected ? '#1a1a1a' : '#fff'};
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 180px;
  border: 1.5px solid #1a1a1a;
  transition: all 0.15s;

  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }
`;

export const ChangeSelectionButton = styled.button`
  background-color: transparent;
  border: 1.5px solid #1a1a1a;
  border-radius: 30px;
  padding: 9px 16px;
  color: #1a1a1a;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  margin-left: 8px;
  white-space: nowrap;
  transition: all 0.15s;

  &:hover {
    background-color: #1a1a1a;
    color: #fff;
  }
`;

export const SelectedGymInfo = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  flex: 1;
`;

// export const SelectedGymTextContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   margin-right: 12px;
// `;

export const SelectedGymName = styled.p`
  margin: 0 0 4px;
  font-weight: 600;
  font-size: 16px;
`;

export const SelectedGymAddress = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${colors.darkGrey || '#666'};
  text-decoration: underline;
`;

export const SelectedGymLogo = styled.img`
  width: 80px;
  height: auto;
  max-height: 80px;
  margin-left: 12px;
  object-fit: contain;
  
  @media (max-width: 768px) {
    width: 60px;
    max-height: 60px;
    padding: 6px;
  }
  
  @media (max-width: 480px) {
    width: 50px;
    max-height: 50px;
    padding: 4px;
  }
`;

export const DaysLeftBadge = styled.div<{ daysLeft: number }>`
  background-color: ${props => {
    if (props.daysLeft > 10) return '#4CAF50'; // Green
    if (props.daysLeft > 5) return '#FF9800'; // Orange
    return '#E53935'; // Red
  }};
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  display: inline-block;
  width: fit-content;
  margin-top: 10px;
`;

export const GymGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px 0;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const GymGridItem = styled.div<{ disabled?: boolean }>`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #eee;
  opacity: ${props => props.disabled ? 0.6 : 1};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  position: relative;
  transition: all 0.2s ease;
  
  &:hover {
    ${props => !props.disabled && `
      background-color: #f9f9f9;
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    `}
  }
`;

export const GymGridItemContent = styled.div`
  display: flex;
  align-items: center;
`;

export const GymGridImageContainer = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 12px;
  border-radius: 4px;
  overflow: hidden;
`;

export const GymGridImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const GymGridDetails = styled.div`
  flex: 1;
`;

export const GymGridName = styled.h4`
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
`;

export const GymGridAddress = styled.p`
  margin: 0;
  font-size: 13px;
  color: #666;
`;

export const UnavailableBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: #f44336;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`;

// export const SelectedGymAction = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   border-radius: 12px;
//   padding: 14px;
//   max-width: 400px;
//   min-width: 260px;
  
//   @media (max-width: 768px) {
//     width: 100%;
//     min-width: unset;
//   }
// `;

export const ChangePaymentMethodLink = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.black};
  text-decoration: underline;
  font-size: 16px;
  font-weight: 500;
  margin-top: 24px;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.colors.darkGrey};
  }
`;

export const ActivationContainer = styled.div`
  width: 90%;
  max-width: 700px;
  margin: 40px auto;
  background-color: ${templateColors.backgroundWhite};
  border-radius: 16px;
  padding: 48px 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  
  @media (max-width: 768px) {
    margin: 30px 20px;
    padding: 40px 24px;
  }
  
  @media (max-width: 480px) {
    margin: 20px 16px;
    padding: 32px 20px;
  }
`;

export const ActivationTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: ${colors.black};
  margin: 0 0 24px 0;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 28px;
  }
  
  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const ActivationDescription = styled.p`
  font-size: 16px;
  color: ${colors.darkGrey || '#666'};
  margin: 0 0 40px 0;
  line-height: 1.6;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 40px;
  
  @media (max-width: 768px) {
    font-size: 15px;
    margin-bottom: 32px;
  }
  
  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 28px;
  }
`;

export const ActivationButton = styled.button`
  background-color: #1a1a1a;
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 16px 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
    padding: 14px 28px;
    font-size: 15px;
  }
`;

export const NonMemberSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f0e8dd;
  width: 100%;
  padding: 20px;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

// add this near other "Selected*" styles
export const RequirementBadge = styled.div`
  display: inline-flex;
  align-items: center;
  background: #dc2626;
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 6px;
  width: fit-content;
  margin: 0 0 6px 0;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 11px;
    padding: 5px 10px;
  }
`;

export const SelectedGymAction = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  padding: 14px;
  max-width: 400px;
  min-width: 260px;

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }
`;

export const SelectedGymTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;               /* allow text to shrink */
  margin-right: 12px;
  overflow-wrap: anywhere;     /* prevent overlap if long names */
`;

